module.exports = __webpack_public_path__ + "static/media/vn.c64db881.webp";